'use client';

export default function Error({
                                  error,
                                  reset,
                              }: { error: Error; reset: () => void }) {
    console.error(error);
    return (
        <div className="min-h-[60vh] flex items-center justify-center px-6 text-center">
            <div>
                <h1 className="text-2xl font-semibold">Something went wrong</h1>
                <p className="mt-2 text-gray-600">
                    A client-side error occurred. Please try again or go back to the homepage.
                </p>

                <div className="mt-6 flex gap-3 justify-center">
                    <button
                        onClick={() => reset()}
                        className="px-4 py-2 rounded-md bg-black text-white"
                    >
                        Try again
                    </button>
                    <a
                        href="/"
                        className="px-4 py-2 rounded-md border border-gray-300"
                    >
                        Go to homepage
                    </a>
                </div>
            </div>
        </div>
    );
}